import styled from '@emotion/styled';
import axios from 'axios';
import { bool, func } from 'prop-types';
import { useTheme } from '@emotion/react';
import { useEffect, useState } from 'react';
import Button from '../../shared/Button';
import Input from '../../shared/Input';
import { Box, Cluster, Flex, Stack } from '../../shared/layouts';
import Modal from '../../shared/Modal';
import { useMediaQuery } from '@dnhb/node_package';
import {useTranslation} from "react-i18next";

const TwoFactorAuthQrCodeModal = ({ isOpen, onRequestClose, onBtnClick }) => {
  const { t } = useTranslation();
  const { breakpoints } = useTheme();
  const isMobileModal = useMediaQuery(
    `(max-width: ${breakpoints.md ?? '604px'})`
  );
  const [manualCodeIsOpen, setManualCodeIsOpen] = useState(false);
  function openManualCode() {
    setManualCodeIsOpen(true);
  }

  const [qrCode, setQrCode] = useState(null);
  const [code, setCode] = useState(['', '', '', '']);

  const Span = styled.span(({ theme }) => ({
    color: theme?.colors?.primary,
    textDecoration: 'underline',
    cursor: 'pointer',
  }));

  useEffect(() => {
    if (isOpen) {
      axios
        .get('/user/settings/multifactor/otp/qr-code')
        .then((resp) => setQrCode(resp.data))
        .catch((err) => console.log(err));

      axios
        .get('/user/settings/multifactor/otp/code')
        .then((resp) => setCode(resp.data.match(/.{4}/g)))
        .catch((err) => console.log(err));
    }
  }, [isOpen]);

  function handleSubmit() {}

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      minWidth="554px"
      showProgressBar
      progressBarValue={2}
      progressBarTotal={6}
    >
      <Stack
        alignItems="center"
        space="l"
        css={(theme) => ({ marginTop: theme.space.xl })}
      >
        {qrCode && (
          <img
            style={{ display: 'block' }}
            width="120px"
            height="120px"
            src={'data:image/png;base64,' + qrCode}
          />
        )}
        <Box fontScale="xl" fontWeight="bold">
          {t('Scan de code')}
        </Box>
        <Box textAlign="center">
          {t('Scan de QR-code met de authenticatie-app op je smartphone. Lukt het niet?') + ' '}
          <Span onClick={openManualCode}>{t('Voer dan handmatig een code in.')}</Span>
        </Box>
        {manualCodeIsOpen && (
          <Box
            bg="background"
            paddingY="l"
            paddingX="xl"
            marginX={{ mobile: '-16px', md: '-32px' }}
            width={{ mobile: 'calc(100% + 32px)', md: 'calc(100% + 64px)' }}
          >
            <Box marginBottom="l" css={{ textAlign: 'center' }}>
              {t('Voer onderstaande code handmatig in om te koppelen')}
            </Box>
            <Cluster as="form" onSubmit={handleSubmit} flex={1}>
              {!isMobileModal && (
                <>
                  <Input
                    value={code[0]}
                    readOnly
                    css={{ input: { textAlign: 'center' } }}
                  />
                  <Input
                    value={code[1]}
                    readOnly
                    css={{ input: { textAlign: 'center' } }}
                  />
                  <Input
                    value={code[2]}
                    readOnly
                    css={{ input: { textAlign: 'center' } }}
                  />
                  <Input
                    value={code[3]}
                    readOnly
                    css={{ input: { textAlign: 'center' } }}
                  />
                </>
              )}
              {isMobileModal && (
                <Input
                  value={code.join('')}
                  readOnly
                  css={{ input: { textAlign: 'center' } }}
                />
              )}
            </Cluster>
          </Box>
        )}
      </Stack>
      <Flex justifyContent="flex-end" marginTop="xl">
        <Button onClick={onBtnClick}>{t('Verder')}</Button>
      </Flex>
    </Modal>
  );
};

TwoFactorAuthQrCodeModal.propTypes = {
  isOpen: bool,
  onRequestClose: func,
  onBtnClick: func,
};

TwoFactorAuthQrCodeModal.defaultProps = {
  isOpen: false,
  onRequestClose: () => {},
  onBtnClick: () => {},
};

export default TwoFactorAuthQrCodeModal;
